class DripOpeningPrice extends HTMLElement {
  connectedCallback() {
    this.expiresAt = Date.parse(this.dataset.expires);
    this.updateExpiry = () => {
      const remaining = this.expiresAt - Date.now();
      this.toggleAttribute('expired', !Number.isFinite(remaining) || remaining <= 0);
      clearTimeout(this.expiryTimer);
      if (remaining > 0) this.expiryTimer = setTimeout(this.updateExpiry, Math.min(remaining, 2147483647));
    };
    this.updateExpiry();
    document.addEventListener('visibilitychange', this.updateExpiry);
    window.addEventListener('pageshow', this.updateExpiry);
  }
  disconnectedCallback() {
    clearTimeout(this.expiryTimer);
    document.removeEventListener('visibilitychange', this.updateExpiry);
    window.removeEventListener('pageshow', this.updateExpiry);
  }
}
if (!customElements.get('drip-opening-price')) customElements.define('drip-opening-price', DripOpeningPrice);
